import Loading from './Loading.vue';

export default {
    install(Vue)
    {
        Vue.component('Loading', Loading);
    }
}